import { createWebgl, webgl } from './core/GL.js'

import Scene from './components/Scene.js'

export default createWebgl({
    shaderChunks: import.meta.glob('./shaders/chunks/*.glsl', { eager: true }),

    setup() {
        const { $renderer } = webgl
        $renderer.setup({ antialias: true, alpha: true })
    },

    start() {
        const { $renderer, $scenes } = webgl
        $renderer.resize()

        $scenes.main = new Scene()
        $scenes.main.init()
    },

    update() {
        const { $scenes } = webgl
        const scene = $scenes.main
        if (!scene) return
        scene.update()
    },

    render() {
        const { $scenes } = webgl
        const scene = $scenes.main
        if (!scene) return
        scene.render()
    }
})
